.main {
  box-sizing: border-box;
  width: 100%;
  max-width: 1920px;
  margin: 32px auto 0;
  padding: 0 32px;
}

.app {
  width: 100%;
}
